import qs from 'qs';
import instance from '../axios';

const authorizationString = 'Basic ' + btoa(process.env.VUE_APP_CLIENT_ID + ":" + process.env.VUE_APP_CLIENT_SECRET);

export const userInfo = ( {...args}) => 
  new Promise ( (resolve, reject) => {
    setTimeout( () => {
      try{
        //let accessToken = context.rootState.auth.token;
        //const authStr = 'Bearer '.concat(args.authToken);
        resolve(instance.get('/users/me' ));
      }catch (err){
        console.log(err);
        reject(new Error(err));
      }
    }, 1000);
  });


export const tokenCall = ({...args}) => new Promise( (resolve, reject)=>{ 
  setTimeout(()=>{
    try{
      let requestData = {
        grant_type: 'password',
        username: args.data.username,
        password: args.data.password,
        scope: 'read',
      };

      let config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': authorizationString,
        }
      }
      resolve(instance.post('/oauth/token', qs.stringify(requestData), config));
    }catch(err){
      reject(new Error(err));
    }
  }, 1000);
});


export const refreshToken = ({...args}) => new Promise( (resolve, reject)=>{ 
  setTimeout(()=>{
    try{
      let requestData = {
        grant_type: 'password',
        username: args.data.username,
        password: args.data.password,
        scope: 'read',
      };
      let config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': authorizationString,
        }
      }
      resolve(instance.post('/oauth/token', qs.stringify(requestData), config));
    }catch(err){
      reject(new Error(err));
    }
  }, 1000);
});
